import { render, staticRenderFns } from "./videojs-player.vue?vue&type=template&id=52d4258a&scoped=true&"
import script from "./videojs-player.vue?vue&type=script&lang=js&"
export * from "./videojs-player.vue?vue&type=script&lang=js&"
import style0 from "./videojs-player.vue?vue&type=style&index=0&id=52d4258a&prod&scoped=true&lang=scss&"
import style1 from "./videojs-player.vue?vue&type=style&index=1&id=52d4258a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4258a",
  null
  
)

export default component.exports